import api from "./baseApi.js";

export default {

  Get(url, arg, type) {
    if (type == "post")
      return api.post(url, arg);
    else
      return api.get(url + "/" +arg);
  },
  
  GetPODs(filter) {
    return api.post("POD/GetPODs", filter);
  },

  GetClientConfigurations(filter) {
    return api.post("POD/GetClientConfigurations", filter);
  },  

  GetClientConfiguration(id) {
    return api.get("POD/GetClientConfiguration/"+id);
  },
 
  AddClientConfigurationInternal(config) {
    return api.post("POD/AddClientConfigurationInternal", config);
  },

  SendToFtp(arg) {
    return api.post("POD/SendToFtp", arg);
  },

  GetImage(id) {
    return api.get("POD/GetImage/"+id, { responseType: 'arraybuffer' })
  },
}